import React from "react";
import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {TICKET_CATEGORIES, TICKET_CATEGORY_ACCESS_ROLES} from "constants/ticket";

// Kuryeler / Şubeler / Başvurular / İletişim Formu alt sekmeleri (içerik dışarıda render edilir)
export const TicketCategoryTabs = ({category, counts, onChange}) => {
    const {t} = useTranslation(["tickets"]);
    const stores = useStore();
    const categories = TICKET_CATEGORIES.filter(
        item =>
            !TICKET_CATEGORY_ACCESS_ROLES[item] ||
            stores.meStore.checkRole(TICKET_CATEGORY_ACCESS_ROLES[item])
    );

    return (
        <Tabs activeKey={category} onChange={onChange}>
            {categories.map(item => (
                <Tabs.TabPane
                    key={item}
                    tab={`${t(`categoryTabs.${item}`, {ns: "tickets"})} (${counts?.[item] ?? 0})`}
                />
            ))}
        </Tabs>
    );
};
